import { useEffect, useState } from "react";

const N = 14;
const reduced = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const ScoreBurst = ({ jobId, children, className = "" }) => {
  const [key, setKey] = useState(0);
  useEffect(() => {
    const f = (e) => { if (e.detail?.jobId === jobId && !reduced()) setKey(Date.now()); };
    window.addEventListener("rpopro:ats-cross", f);
    return () => window.removeEventListener("rpopro:ats-cross", f);
  }, [jobId]);
  useEffect(() => { if (!key) return; const t = setTimeout(() => setKey(0), 1600); return () => clearTimeout(t); }, [key]);
  return (
    <span className={`relative inline-block ${className}`}>
      {children}
      {key > 0 && (
        <span key={key} aria-hidden className="pointer-events-none absolute inset-0 z-10" data-testid={`score-burst-${jobId}`}>
          <span className="score-burst-ring absolute inset-0 rounded-2xl" />
          {Array.from({ length: N }, (_, i) => {
            const a = (i / N) * Math.PI * 2, d = 46 + (i % 3) * 14;
            return <span key={i} className="score-burst-dot absolute left-1/2 top-1/2" style={{ "--dx": `${Math.cos(a) * d}px`, "--dy": `${Math.sin(a) * d}px`, "--rot": `${i * 47}deg`, animationDelay: `${(i % 4) * 30}ms`, background: i % 3 ? "#D4AF37" : "#F3C649", width: i % 2 ? 6 : 4, height: i % 2 ? 6 : 10 }} />;
          })}
        </span>
      )}
    </span>
  );
};
